import styled from 'styled-components';
import {Container} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';

export const PageWrapper = styled.div`
  
`

export const NavSection = styled(Container)`
  /*padding: 0 15px;
  @media screen and (min-width: 768px) {
    padding: 0 40px;
  }*/
`

export const PageSection = styled.div`
  padding: 50px 0 60px;
  &.bg-blue{
    background-color: #EAF4FC;
  }
`

export const HeaderImage = styled.img`
  width: 100%;
  padding-left: -15px;
  padding-right: -15px;
`

export const Headline = styled.h3`
  font-family: Manrope, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 180%;
  text-align: center;
`

export const HeadContent = styled.p`
  padding: 50px 0;
  font-family: Manrope, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 200%;
  color: #808387;
`

export const ApplyBtn = styled(Button)`
  width: 124px;
  height: 48px;
  background-color: #80ABED;
  box-sizing: border-box;
  border-radius: 8px ;
  text-align: center;
  border: none;
`;

export const HiringContainer = styled.div`
  position: relative;
  margin-top: 160px;
  padding: 50px;
  width: 100%;
  text-align: center;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%), rgba(234, 244, 252, 0.7);
  box-shadow: -8.49px -8.49px 5px rgba(255, 255, 255, 0.33), 8.17px 8.17px 12px rgba(36, 38, 89, 0.1);
  border-radius: 20px;
`